import { FC, HTMLAttributes } from 'react'

import { Theme } from '@/ui/theme/theme'
import { StyledAs } from '@/ui/typings/helpers'

import { BodyTextBase } from './styled'

export type BodyTextProps = {
  /**
   * The type of element you want text to be rendered in
   * @default 'p'
   */
  as?: StyledAs
  /**
   * The color of the text
   * @default 'inherit'
   */
  color?: string
  /**
   * Defines font weight of text
   * @default 'regular'
   */
  weight?: keyof Theme['fontWeight']
  /**
   * The size of the text
   * @default 'medium'
   */
  size?: keyof Theme['typography']['body']
  /**
   * The alignment of the text
   * @default 'start'
   */
  textAlign?: string
} & HTMLAttributes<HTMLElement>

export const BodyText: FC<BodyTextProps> = ({
  as = 'p',
  color = 'inherit',
  size = 'medium',
  textAlign = 'start',
  weight = 'regular',
  ...rest
}: BodyTextProps) => {
  return (
    <BodyTextBase
      $color={color}
      $weight={weight}
      $size={size}
      $textAlign={textAlign}
      as={as}
      {...rest}
    />
  )
}
